import React, { Component, Fragment} from 'react';
import { MsalContext } from "../../Auth/msal-context";
import {Row, Col, OverlayTrigger, Tooltip, Button, DropdownButton, Dropdown, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import {  FeatureClickTracker } from '../../Helpers/FeatureHelpers';
import moment from 'moment';
import Swal from 'sweetalert2'
import AutoComplete from '../Util/AutoComplete';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './SupportApps.scss';
import Auth from '../../Auth/Auth';
import RequestBackup from '../Altocumulus/RequestBackup';
import BackfillRequest from '../Altocumulus/BackfillRequest';

const auth = new Auth();

    function copy(e){
        let copybtn = e.target;
        copybtn.className = "fas fa-check copy-btn";
        setTimeout(function(){
            copybtn.className = "far fa-copy copy-btn";
        },1500);
    }

  function DateFormatter(cell, row) {  
    return (
      <span>{moment(cell).format('YYYY-MM-DD')}</span>
    );
  }

  function ExpandFormatter(cell, row) {
    return (
      <span><i className="fas fa-chevron-down"></i></span>
    );
  }
  

  function htmlFormatter(cell){
    return (
      <span>{cell.substr((cell.length - 6),cell.length)}<i className="far fa-copy copy-btn"  onClick={(e) => { copy(e)}} data-clipboard-text={cell}></i></span>
    );
  }

  function htmlFormatter2(cell, row){
      
      function OpenSupportApp(link){
          if(row.OwnerComment){
            Swal.fire({
                title: 'Support App has a Comment',
                html: '<a href="mailto:' + row.LeaserEmail +'">' + row.LeaserEmail + '<a/>' + ' said:  ' + '<strong>' + row.OwnerComment + '</strong>' ,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#aaa',
                confirmButtonText: 'Continue'
              }).then((result) => {
                if (result.value) {
                    window.open(link,'_blank');
                }
              })
          } else {
            window.open(link,'_blank');
          }
        
      }
    return (
      <span><Button variant="link" onClick={() => { FeatureClickTracker("Support App - " + cell); OpenSupportApp(`https://supportapp.dayforcehcm.com/support/supportlogin/?ns=${cell}`) } }  target="_blank" rel="noopener noreferrer">{cell}</Button><i className="far fa-copy copy-btn" onClick={(e) => { FeatureClickTracker("Support App Copy - " + cell); copy(e) }} data-clipboard-text={cell}></i></span>
    );
  }

  function Icon(cell, row, rowIndex, formatExtraData){
    return (
        <span className="expand-cell"><div className="support-icon">{cell.substr(0,2)}</div></span>
    );
  }

  function indication() {
    return ( <p>No Support Apps Available</p>);
  }

export class SupportApps extends Component {
    static contextType = MsalContext;

    constructor(props){
        super(props);
        this.state = {
            namespace : this.props.namespace,
            show: this.props.show,
            SupportApps: [],
            dashboardInfoLoading: true
        };
    }

    componentWillMount(){
        const { userAltocumulus } = this.context;
        if(userAltocumulus){
            this.getDashboardSupportApp(this.props.namespace);
        }

    }

    componentDidUpdate(prevProps){
        if(prevProps.namespace !== this.props.namespace){
            this.getDashboardSupportApp(this.props.namespace);
        }
    }

    async getDashboardSupportApp(namespace){
        this.setState({
            dashboardInfoLoading : true
        });

        let accessToken = await auth.getToken();

        fetch('/api/getDashboardSupportApp', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                "namespace" : namespace
            }
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            if(data[0] && data[0].length > 0){
                this.setState({
                    SupportApps : data[0],
                    dashboardInfoLoading: false
                });
            } else {
                this.setState({
                    dashboardInfoLoading: false
                });
            }
        }).catch((error) => {
            window.apiError(error);
        });
    }

    

    render(){
        return (
            <div className="support-app-container">
                <strong>Support App</strong>
                {this.state.SupportApps.map((items, index) =>
                    <OverlayTrigger
                    key={index}
                    placement={"top"}
                    overlay={
                        <Tooltip id={`tooltip-top`}>
                        <div className="text-left support-tooltip">
                            <p>
                                <strong>DB Server: </strong>
                                {items.DBServer}
                                <br />
                                <strong>Support App: </strong>
                                {items.SupportAppName}
                                <br />

                                <strong>App Version:</strong>
                                {items.AppVersion}
                                <br />
                                <strong>Owner:</strong>
                                {items.LeaserEmail}
                                <br />
                                <strong>Est. Backup Date:</strong>
                                {items.CreatedDate}
                                <br />
                                <strong>Days Left:</strong>
                                {items.DaysLeftOnReservation}
                            </p>
                        </div>
                        </Tooltip>
                    }
                    >
                    <div key={index} className="support-app">
                        <a href={`https://supportapp.dayforcehcm.com/support/supportlogin/?ns=${items.SupportAppName}`} target="_blank"  rel="noopener noreferrer">{items.SupportAppName.substr(0,2)}</a>
                    </div>
                    </OverlayTrigger>
                )}
                {this.state.show !== "SA-ONLY" && (
                    <Fragment>                   
                        <strong>Triage</strong>                    
                        {["Prod","Support","Test"].map((items, index) =>
                            <OverlayTrigger
                            key={index}
                            placement={"top"}
                            overlay={
                                <Tooltip id={`tooltip-top`}>
                                <div className="text-left support-tooltip">
                                    <p>
                                        <strong>Triage Environment: </strong>
                                        {items}
                                        <br />
                                        <strong>Please note that in order to properly access this Triage URL, you<br />
                                        must belong to the Support Pod for this client or have an active<br />
                                        case for this client assigned to you.</strong>
                                    </p>
                                </div>
                                </Tooltip>
                            }
                            >
                                <div key={index} className="support-app">
                                    <a href={`https://triage.dayforce.com/?ns=${this.state.SupportAppClient}&env=${items}&source=FetchBeta`} target="_blank"  rel="noopener noreferrer">{items.substr(0,2)}</a>
                                </div>
                            </OverlayTrigger>
                        )}
                    </Fragment>                    
                )}
            </div>
        )
    }
}

export class SupportAppsDetailed extends Component {
    static contextType = MsalContext;

    constructor(props){
        super(props)
        this.state = {
            namespace : this.props.namespace,
            show: this.props.show,
            SupportApps: [],
            dashboardInfoLoading: true,
            userAltocumulus: false,
            userAltocumulusAccess: false,
            SupportAppExists: false,
            BackupInProgress: false,
            hasAccesstoRegister: false,
            register: false,
            showNamespaceInput: false,
            searchQuery: "",
            expanded: [0, 1] 
        }
    }

    componentDidMount(){
        const { userAltocumulus, userAltocumulusAccess } = this.context
        if(this.props.namespace === "" || this.props.namespace === "CeridianDFSaaSNotRealNamespace" || this.props.namespace === "not applicable"){
            this.setState({
                showNamespaceInput: true
            })            
        }
        if(userAltocumulus){
            this.setState({
                userAltocumulus : true,
                userAltocumulusAccess: userAltocumulusAccess,
                hasAccesstoRegister: (userAltocumulus.TeamId !== 1 && userAltocumulus.TeamId !== 16) ? true : false
            })
            this.getDashboardSupportApp(this.props.namespace);
            setTimeout(function(){
                let copy = document.getElementsByClassName("copy-btn");
                for(let i = 0; i < copy.length; i++){
                    copy[i].addEventListener("click", function(){
                        copy[i].className = "fas fa-check copy-btn";
                        setTimeout(function(){
                            copy[i].className = "far fa-copy copy-btn";
                        },2000)
                    })
                }
            },1500)
        }            
    }

    componentDidUpdate(prevProps){    
        if(prevProps.namespace !== this.props.namespace){
                if(this.props.namespace === "" || this.props.namespace === "CeridianDFSaaSNotRealNamespace" || this.props.namespace === "not applicable"){
                    this.setState({
                        showNamespaceInput: true
                    })            
                }
                const { userAltocumulus, userAltocumulusAccess } = this.context
                if(userAltocumulus){
                    this.setState({
                        userAltocumulus : true,
                        userAltocumulusAccess: userAltocumulusAccess,
                        hasAccesstoRegister: (userAltocumulus.TeamId !== 1 && userAltocumulus.TeamId !== 16) ? true : false
                    })

                    this.getDashboardSupportApp(this.props.namespace);
                    setTimeout(function(){
                        let copy = document.getElementsByClassName("copy-btn");
                        for(let i = 0; i < copy.length; i++){
                            copy[i].addEventListener("click", function(){
                                copy[i].className = "fas fa-check copy-btn";
                                setTimeout(function(){
                                    copy[i].className = "far fa-copy copy-btn";
                                },2000)
                            })
                        }
                    },1500);
            }
        }
    }

    async getDashboardSupportApp(namespace){       
        const { userAltocumulus, userAltocumulusAccess } = this.context 

        this.setState({
            SupportApps: [],
            dashboardInfoLoading : true
        })

        let accessToken = await auth.getToken()

        fetch('/api/getDashboardSupportApp', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                "namespace" : namespace,
                "teamid": userAltocumulus.TeamId,
                "isadmin": userAltocumulus.IsAdmin
            }
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }]
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json()
        }).then(data => {
            for(let i = 0; i < data[0].length; i++){
                data[0][i].Locale = data[0][i].SupportAppName.substr(0,2)
            }
            if(data[0] && data[0].length > 0){
                this.setState({
                    SupportApps : data[0],
                    dashboardInfoLoading: false
                })
            } else {
                this.setState({
                    dashboardInfoLoading: false
                })
            }
        }).catch((error) => {
            window.apiError(error)
        });

        fetch('/api/NamespaceBackupInProgress', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                "namespace" : namespace
            }
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }]
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json()
        }).then(data => {
            if(data && data.length > 0){
                this.setState({
                    SupportAppExists: data[0].hasBackup ? true : false,
                    BackupInProgress: data[0].hasBackupInProgress ? true : false
                })
            }
        }).catch((error) => {
            window.apiError(error)
        });
        
    } 
    
    handleBtnClick = (id) => {
        if (!this.state.expanded.includes(id)) {
          this.setState(() => ({
            expanded: [...this.state.expanded, id]
          }));
        } else {
          this.setState(() => ({
            expanded: this.state.expanded.filter(x => x !== id)
          }));
        }
    }

    rowClasses = (row, rowIndex) => {
        const { user } = this.context
        let classes = null;

        if (row.LeaserEmail && row.LeaserEmail.toLowerCase() === (user ? user.username.toLowerCase()  : "")) {
          classes = 'my-support-app';
        }
      
        return classes;
    };
    
    render(){

        const expandRow = {            
            renderer: row => (                     
              <div style={{ padding: 0, marginTop: "-19px"}}> 
                  <p className="mb-1"><strong className="float-left">Owner:  </strong><a href={`mailto:${row.LeaserEmail}`}>{row.LeaserEmail}</a> <i className="far fa-copy copy-btn" data-clipboard-text={row.LeaserEmail} onClick={(e) => copy(e)}></i></p>                   
                  <p className="mb-1"><strong className="float-left">App Log Folder:  </strong>{(row.AppLogFolder).split(".").shift()}<i className="far fa-copy copy-btn" data-clipboard-text={row.AppLogFolder} onClick={(e) => copy(e)}></i></p>
                  <p className="mb-1"><strong className="float-left">BJE Log Folder:  </strong>{(row.BJELogFolder).split(".").shift()}<i className="far fa-copy copy-btn" data-clipboard-text={row.BJELogFolder} onClick={(e) => copy(e)}></i></p>
                  <p className="mb-1"><strong className="float-left">Import Export Folder:  </strong>{(row.ImportExportFolder).substr(0,17)} <i className="far fa-copy copy-btn" data-clipboard-text={row.ImportExportFolder} onClick={(e) => copy(e)}></i></p>
                  <p className="mb-1"><strong className="float-left">Days Left:  </strong>{row.DaysLeftOnReservation}</p>                  
                  <p className="mb-1"><strong className="float-left">App Version:  </strong>{row.AppVersion}</p>
              </div>
            ),
            expanded: this.state.expanded,
            parentClassName: (isExpanded, row, rowIndex) => {
                if (isExpanded){
                    return 'expanded';
                } 
              }
          };

        const columns = [{
            dataField: 'Locale',
            text: '',
            sort: true,
            formatter: Icon,
            formatExtraData: {
                app : this
            }
          },{
            dataField: 'SupportAppName',
            text: 'Name',
            sort: true,
            formatter: htmlFormatter2
          }, {
            dataField: 'DBServer',
            text: 'Server',
            sort: true,
            formatter: htmlFormatter
          }, {
            dataField: 'CreatedDate',
            text: 'Date',
            sort: true,
            formatter: DateFormatter
          }, {
            dataField: '',
            text: '',
            sort: false,
            formatter: ExpandFormatter
          }];
        
          const defaultSorted = [{
            dataField: 'CreatedDate',
            order: 'desc'
          }];

        return (
            <div className="support-app-container support-app-detailed">
                <div className="icon-container">
                    {this.state.SupportAppExists && (
                        <OverlayTrigger
                            placement={"top"}
                            overlay={
                                <Tooltip >
                                    Backup Available
                                </Tooltip>
                            }>
                                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M20 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H20C21.1 18 22 17.1 22 16V2C22 0.9 21.1 0 20 0ZM8 13H14.5C15.88 13 17 11.88 17 10.5C17 9.12 15.88 8 14.5 8H14.45C14.21 6.31 12.76 5 11 5C9.6 5 8.4 5.83 7.84 7.02H7.68C6.17 7.18 5 8.45 5 10C5 11.66 6.34 13 8 13ZM3 16.01H19C19.55 16.01 20 15.56 20 15.01V2.99C20 2.44 19.55 1.99 19 1.99H3C2.45 1.99 2 2.44 2 2.99V15.01C2 15.56 2.45 16.01 3 16.01Z" fill="#689df6"/>
                                </svg>
                        </OverlayTrigger>
                    )}   

                     {this.state.BackupInProgress && (
                        <OverlayTrigger
                            placement={"top"}
                            overlay={
                                <Tooltip >
                                    Backup In Progress
                                </Tooltip>
                            }>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="4" width="20" height="16">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M2 6C2 7.1 2.9 8 4 8H20C21.1 8 22 7.1 22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6ZM20 20H4C2.9 20 2 19.1 2 18C2 16.9 2.9 16 4 16H20C21.1 16 22 16.9 22 18C22 19.1 21.1 20 20 20ZM6 17H4V19H6V17ZM4 7H6V5H4V7ZM4 14H20C21.1 14 22 13.1 22 12C22 10.9 21.1 10 20 10H4C2.9 10 2 10.9 2 12C2 13.1 2.9 14 4 14ZM6 11H4V13H6V11Z" fill="#689df6"/>
                                    </mask>
                                    <g mask="url(#mask0)">
                                    <rect width="24" height="24" fill="#689df6"/>
                                    </g>
                                </svg>
                        </OverlayTrigger>
                    )}              

                </div>
                {(this.state.userAltocumulusAccess || 1 === 1) && (
                    <>
                        <p className="m-0" style={{ fontWeight: 600, fontSize: "13px", color: "rgb(158, 158, 158)" }}>{this.state.namespaceSearch}</p>
                        {this.state.showNamespaceInput && (
                            <AutoComplete submit={(searchQuery) => {this.getDashboardSupportApp(searchQuery); this.setState({ namespaceSearch : searchQuery}); }} />
                        )}
                        
                        <BootstrapTable
                            bootstrap4
                            keyField="SupportAppName"
                            data={ this.state.SupportApps }
                            columns={ columns }
                            defaultSorted={ defaultSorted } 
                            expandRow={ expandRow }
                            rowClasses={ this.rowClasses }
                            noDataIndication={ indication } 
                        />

                        {this.state.userAltocumulusAccess && (
                            <>              
                                <div className="request-container">
                                    <Button className="mr-1" onClick={() =>  this.setState({ showRequestModal : true })} disabled={(this.props.namespace === "" || this.props.namespace === "CeridianDFSaaSNotRealNamespace" || this.props.namespace === "not applicable") && !this.state.namespaceSearch}>Request Backup</Button>
                                    <Button className="ml-1" onClick={() => { this.props.initBackfill(); this.setState({ showBackfillModal : true }) }} disabled={(this.props.namespace === "" || this.props.namespace === "CeridianDFSaaSNotRealNamespace" || this.props.namespace === "not applicable") && !this.state.namespaceSearch}>Backfill</Button>
                                </div>

                                <Modal size="lg" show={this.state.showRequestModal} onHide={() =>  this.setState({ showRequestModal : false })} centered>
                                    {this.state.showRequestModal && (
                                        <RequestBackup namespace={this.state.namespaceSearch || this.state.namespace} close={() => this.setState({ showRequestModal : false })} useExistingBackup={() => { this.props.initBackfill(); this.setState({ showRequestModal : false, showBackfillModal: true })} }  UserNotRegistered={null} />       
                                    )}
                                </Modal>
                                <Modal size="lg" show={this.state.showBackfillModal} onHide={() =>  this.setState({ showBackfillModal : false })} centered>
                                    {this.state.showBackfillModal && (
                                        <BackfillRequest namespace={this.state.namespaceSearch || this.state.namespace} server={this.state.SupportApps.length > 0 && this.state.SupportApps[0].DBServer} caseNumber={this.props.caseNumber} close={() => this.setState({ showBackfillModal : false })} />       
                                    )}
                                </Modal> 
                            </>
                        )}       

                    </>
                )}

                {(!this.state.userAltocumulusAccess && 1 === 0) && (
                    <div className="d-flex text-center" style={{ minHeight: "200px" }}>
                        <h6 className="m-auto" style={{ fontWeight: 200 }} >
                            You dont have access to this module
                            {this.state.hasAccesstoRegister && (                            
                                <Button variant="primary" className="w-50 mt-3" onClick={() => this.setState({ register : true})}>Register</Button>
                            )}
                        </h6>
                    </div>                    
                )}

                {this.state.register && (
                    <Modal size="lg" show={this.state.register} onHide={() =>  this.setState({ register : false })} centered>
                        <RequestBackup UserNotRegistered={Math.random() * 1000} userRegistered={(data) => this.setState({ userAltocumulusAccess : data })  } />          
                    </Modal>                   
                )}
                    
            </div>
        )
    }
}